import {Action} from '@ngrx/store';

export const RENAME_ACTION = 'RENAME_ACTION';

export class RenameActions implements Action {
  readonly type = RENAME_ACTION;

  constructor(public payload: any) {
  }
}
